// extracted by mini-css-extract-plugin
module.exports = {"menu":"LeftMenu_menu__2eGbP"};